// ! could not find a workaround
import { Component, PropsWithChildren } from "react";
import "./errorBoundary.css";
import ErrorElement from "./ErrorElement";

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<PropsWithChildren, State> {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    // componentDidCatch() {
    //     this.setState({ hasError: true });
    // }

    // preffer to use getDerivedStateFromError instead of componentDidCatch to avoid unmounting the component tree
    // and remounting it again. This is important for the react-router-dom to work properly
    // https://reactjs.org/docs/react-component.html#static-getderivedstatefromerror
    // https://reactjs.org/docs/error-boundaries.html#introducing-an-error-boundary
    //
    static getDerivedStateFromError() {
        return { hasError: true };
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;

        if (hasError) {
            return <ErrorElement />;
        }

        return children;
    }
}

export default ErrorBoundary;
